export default __webpack_public_path__ + "static/media/san_nicolas_de_los_arroyos.48c9ac8d.jpg";